var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlgoTradingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.997,
    height: 111.04,
    viewBox: "0 0 140.997 111.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "algo_trading-icon",
    transform: "translate(-95.247 -19.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-50",
    transform: "translate(95.747 62.848)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 109.593,
    height: 65.458,
    rx: 10.93,
    transform: "translate(0)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16023",
    "data-name": "Path 16023",
    d: "M10.13.049a10.142,10.142,0,0,1,.039,20.283A10.142,10.142,0,0,1,10.13.049Z",
    transform: "translate(2.431 53.304) rotate(-68.33)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16024",
    "data-name": "Path 16024",
    d: "M3.933.009a3.907,3.907,0,1,1-3.924,3.9A3.926,3.926,0,0,1,3.933.009Z",
    transform: "translate(11.13 44.402) rotate(-9.24)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    y1: 4.043,
    x2: 4.644,
    transform: "translate(18.134 40.632)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y2: 6.187,
    transform: "translate(15.646 51.538)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 3.42,
    height: 14.826,
    transform: "translate(10.295 13.354)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 3.42,
    height: 8.99,
    transform: "translate(14.939 19.184)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 3.42,
    height: 18.71,
    transform: "translate(19.583 9.465)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 3.42,
    height: 22.115,
    transform: "translate(24.222 6.064)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 3.42,
    height: 12.879,
    transform: "translate(28.866 15.296)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 3.42,
    height: 9.72,
    transform: "translate(33.51 18.455)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 3.42,
    height: 5.831,
    transform: "translate(38.154 22.344)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 3.42,
    height: 14.826,
    transform: "translate(42.794 13.354)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 3.42,
    height: 10.449,
    transform: "translate(47.438 17.726)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 3.42,
    height: 14.826,
    transform: "translate(52.081 13.354)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 3.42,
    height: 5.589,
    transform: "translate(56.725 22.585)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 3.42,
    height: 14.826,
    transform: "translate(61.369 13.354)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 73.012,
    transform: "translate(4.189 28.175)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 14.024,
    transform: "translate(57.927 31.839)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 14.024,
    transform: "translate(57.927 34.111)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x2: 14.024,
    transform: "translate(57.927 36.383)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x2: 14.024,
    transform: "translate(57.927 38.655)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 14.029,
    transform: "translate(27.912 50.655)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 14.029,
    transform: "translate(27.912 52.926)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 14.029,
    transform: "translate(27.912 55.198)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 14.029,
    transform: "translate(27.912 57.47)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    y2: 52.878,
    transform: "translate(79.454 5.238)",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-50",
    transform: "translate(147.903 19.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M192.33,157.557l2.055-5.457,1.486,3.409Z",
    transform: "translate(-180.072 -112.505)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M180.668,135.461a34.2,34.2,0,0,1-3.635-4.81c-1.369-2.273-2.4-3.3-3.658-3.3a21.429,21.429,0,0,1-4.68,0c-1.482-.341-5.375-3.638-5.375-1.707s1.829,2.614,2.859,2.715a17.829,17.829,0,0,1,2.933.8,8.64,8.64,0,0,1-2.247,1.939c-1.373.8-4.345.341-3.2,1.365s3.315,2.614,4.68,2.614,5.831-1.819,5.831-1.819l3.085,5.8Z",
    transform: "translate(-162.377 -95.944)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M191.813,136.2a14.182,14.182,0,0,0-1.47-2.091c-.39,4.154-2.793,5.2-2.793,5.2l.035.039c.78-.3,1.373-.531,1.373-.531l.741,1.4a5.913,5.913,0,0,0,2.375-3.584Z",
    transform: "translate(-177.156 -101.493)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M163.869,137.295s.956-2.87.671-3.921-1.17-.252-1.459.675a11.893,11.893,0,0,0-.725,3.219C162.441,137.919,162.944,138.854,163.869,137.295Z",
    transform: "translate(-161.782 -100.737)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M162.327,145.9a3.313,3.313,0,0,0,1.677-.113c.983-.295,1.9-.089,2.141-.776s-.082-1.423-.956-1.264a18.513,18.513,0,0,0-3.066.729C161.754,144.7,161.727,145.281,162.327,145.9Z",
    transform: "translate(-161.485 -107.377)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M162.547,139.6s.191-3.018-.351-3.964-1.19.05-1.24,1.02a11.458,11.458,0,0,0,.121,3.3C161.33,140.572,162.047,141.363,162.547,139.6Z",
    transform: "translate(-160.901 -102.195)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M181.19,138.6s1.95-3.7,3.07-4.17a1.81,1.81,0,0,1,1.728.2,1.788,1.788,0,0,1,.752,1.561,3.488,3.488,0,0,1-1.888,3.1c-.948.411-3.011,1.117-3.011,1.117Z",
    transform: "translate(-173.277 -101.607)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M167.982,146.518a3.55,3.55,0,0,0,1.7-.586c.932-.582,1.95-.628,1.993-1.392s-.488-1.447-1.346-1.036a19.675,19.675,0,0,0-2.956,1.617C167.05,145.456,167.186,146.049,167.982,146.518Z",
    transform: "translate(-164.749 -107.168)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M166.527,141.192s-.663-3.169-1.49-3.991-1.213.388-.987,1.4a12.545,12.545,0,0,0,1.061,3.374C165.544,142.538,166.507,143.131,166.527,141.192Z",
    transform: "translate(-162.783 -103.218)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M174.428,148.311a3.548,3.548,0,0,0,1.654-.706c.885-.644,1.888-.776,1.888-1.524s-.589-1.408-1.416-.939a19.557,19.557,0,0,0-2.832,1.819C173.43,147.314,173.6,147.9,174.428,148.311Z",
    transform: "translate(-168.641 -108.149)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M172.48,143.426s-.885-3.1-1.771-3.879-1.17.469-.885,1.466a12.021,12.021,0,0,0,1.3,3.289C171.594,144.83,172.6,145.361,172.48,143.426Z",
    transform: "translate(-166.279 -104.672)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M171.95,129.35a1.856,1.856,0,0,1,.035.993.913.913,0,0,1-1.045.687,19,19,0,0,1,2.816.776c.558-.279.417-1.164.269-1.718a5.405,5.405,0,0,1-.686-.1,6.108,6.108,0,0,1-1.389-.632Z",
    transform: "translate(-167.025 -98.579)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M248.2,225.817s-2.137,3.491-2.137,12.578,3.811,24.556,3.811,24.556a36.815,36.815,0,0,0,9.751,2.882,32.116,32.116,0,0,0,11.28-.454s5.944-15.9,7.161-24.556-.456-13.187-.456-13.187l-27.434-4.266Z",
    transform: "translate(-212.846 -156.132)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M227.424,121.325s-10.289,3.3-10.632,3.979-8.8,15.383-8.8,15.383l-9.872-8.533-5.788,5.9s13.487,13.3,14.634,13.758,1.143,1.02,1.712.566,9.946-8.533,9.946-8.533,1.95,5,1.829,6.706-6.63,12.962-6.63,12.962,2.4,4.546,5.031,6.365,4.8,3.3,4.8,3.3l2.4-5.818,1.6,6.14a53.738,53.738,0,0,0,8.686-1.707,31.343,31.343,0,0,0,10.074-4.992l-5.261-16.372,5.6-10.8,11.888,12.509a76.44,76.44,0,0,0,8.495-1.594c1.716-.489-4.267-7.618-6.435-10.573s-6.529-11.481-8.128-13.633-15.09-6.024-15.09-6.024S229.6,119.742,227.424,121.325Z",
    transform: "translate(-180.072 -92.985)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 2.469,
    cy: 2.378,
    rx: 2.469,
    ry: 2.378,
    transform: "translate(53.016 42.124)",
    fill: "#3fb9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M322.05,162.07l3.639,3.18-3.939-1.4",
    transform: "translate(-259.015 -118.608)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M333.949,135.966s-3.436-.593-5.679,4.46",
    transform: "translate(-262.992 -102.616)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M257,242.361l6.116,5.2,2.4-5.818,1.6,6.14a39.8,39.8,0,0,0,16.8-5.539",
    transform: "translate(-219.519 -167.377)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M275.2,114.908s-1.279.07-2.34,2.191-2.274,7.075-3.842,8.773-1.065,1.769-.211,1.551a21.342,21.342,0,0,0,3.343-1.838,33.12,33.12,0,0,0,.64,5.515c.5,1.769.07,6.508.5,8.347a13.545,13.545,0,0,1,.429,2.327s2.418-7.284,3.7-9.479,3.694-6.078,3.694-6.078l4.977,2.715s-.07-4.6-.215-6.982,1.56-5.236-.355-6.861S275.2,114.908,275.2,114.908Z",
    transform: "translate(-226.231 -89.377)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M284.89,103.856s-.14,3.4,0,7.214-.07,15.069-.07,15.069,8.818-14.995,9.6-16.127l.425-6.931S288.791,106.191,284.89,103.856Z",
    transform: "translate(-236.489 -82.498)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M284.9,103.862s-.109,2.622-.039,5.845a6.5,6.5,0,0,0,3.413,2.079,7.828,7.828,0,0,0,5.663-.989c.238-.388.413-.663.5-.776l.425-6.931S288.8,106.2,284.9,103.862Z",
    transform: "translate(-236.501 -82.504)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M294.86,103.08s-6.045,3.1-9.957.776c0,0-.051,1.241-.062,3.06,1.049,1.016,3.253,3.037,4.224,3.037s3.9-2.056,5.573-3.266Z",
    transform: "translate(-236.501 -82.498)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M276.017,76.579a3.931,3.931,0,0,0-.714.415c-.519.027-.878,1.326-.8,2.905s.566,2.839,1.084,2.812h0a3.843,3.843,0,0,0,.753.345c.589-.027.995-1.5.9-3.289S276.606,76.548,276.017,76.579Z",
    transform: "translate(-230.189 -66.276)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M282.331,50.114a7.967,7.967,0,0,0-6.014,4.235c-1.529,2.975-.417,4.732-.417,7.059a40.634,40.634,0,0,0,1.587,9.134c.417.663,3.842,4.984,5.6,5.232s6.346-3.82,7.1-5.066,1.509-6.229,1.833-9.22.082-8.056-1.837-9.635S284.917,49.781,282.331,50.114Z",
    transform: "translate(-230.809 -50.016)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M292.862,79.188h-1.537s.172-1.078-1.486-1.986a2.165,2.165,0,0,0-2.453.706,3.564,3.564,0,0,0-1.135,2.506l-.3,3.436a.65.65,0,0,1-.219.466.658.658,0,0,1-.491.163h0a.653.653,0,0,1-.6-.605c-.094-1.451-.254-5.861-1.49-6.559-2.114-1.195-3.2,1.478-3.2,1.478H279",
    transform: "translate(-232.939 -66.538)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M303.447,84.425a1.023,1.023,0,0,0,.113-.462,1.1,1.1,0,0,0-2.2,0,1.024,1.024,0,0,0,.113.462Z",
    transform: "translate(-246.578 -70.127)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M286.887,84.425a1.023,1.023,0,0,0,.113-.462,1.1,1.1,0,0,0-2.2,0,1.023,1.023,0,0,0,.113.462Z",
    transform: "translate(-236.476 -70.127)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M294.1,101.249c-.741.566-1.486.512-2.687.454s-1.486-.624-1.486-.624l1.373-.388.573.624.569-.512Z",
    transform: "translate(-239.606 -81.035)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M291,102.86a2.556,2.556,0,0,0,1.314,1.249c.913.341,1.771-1.078,1.771-1.078A13.212,13.212,0,0,1,291,102.86Z",
    transform: "translate(-240.258 -82.363)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M287.445,50.114a8.065,8.065,0,0,0-3.483,1.354,10.924,10.924,0,0,0,0,2.447,12.569,12.569,0,0,0,1.658,3.8h5.772a11.233,11.233,0,0,0,2.4-4.146c.335-1.028.573-1.745.741-2.242A11.886,11.886,0,0,0,287.445,50.114Z",
    transform: "translate(-235.924 -50.015)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M309.764,64.586c0,.566,1.088,3.692,1.088,4.833s-.745,3.634-1.658,4.317a2.966,2.966,0,0,0-1.314,2.447,32.385,32.385,0,0,0,0,3.588,12.256,12.256,0,0,0,2.032-2.141c.753-1.245,1.5-6.229,1.837-9.22a20.437,20.437,0,0,0-.437-7.09A16.315,16.315,0,0,0,309.764,64.586Z",
    transform: "translate(-250.524 -56.935)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M316.09,82.213a8.453,8.453,0,0,0,.277-4.689l.031-.508-.39-.225a.5.5,0,0,0-.339-.2c-.589-.031-1.151,1.389-1.256,3.177s.289,3.27.878,3.3a.493.493,0,0,0,.359-.159l.39-.178Z",
    transform: "translate(-254.529 -66.282)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M318.533,80.578c-.094,1.579-.589,2.835-1.112,2.8s-.862-1.334-.78-2.913.589-2.831,1.112-2.8S318.622,79,318.533,80.578Z",
    transform: "translate(-255.891 -66.943)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M278.378,74.9a8.412,8.412,0,0,1-1.56-4.321,38.4,38.4,0,0,1,.285-5.628c0-.171-.722-1.97-1.045-2.789-1.264,2.762-.25,4.472-.25,6.7A40.632,40.632,0,0,0,277.4,78a22.48,22.48,0,0,0,1.56,1.974C278.9,77.841,279.158,75.805,278.378,74.9Z",
    transform: "translate(-230.757 -57.449)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M294.163,110.209a9.973,9.973,0,0,0-2.586-2.226c-.589-.147-1.7,1.21-2.208,1.939a2.975,2.975,0,0,0,4.793.287Z",
    transform: "translate(-239.264 -85.492)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M316.195,207.615s-4.77-4.363-5.534-4.554-5.07,1.963-5.07,2.529.952.508,1.907.256,2.8-.95,2.8-.95a50.212,50.212,0,0,0,2.672,5.43c.636.749,1.08,1.835,2.34,1.454a5.441,5.441,0,0,0,1.974-1.008Z",
    transform: "translate(-249.158 -143.693)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M319.413,208.062A13.58,13.58,0,0,0,321,209.326c.32.128.956,0,.511-1.326a3.268,3.268,0,0,0-1.911-2.153C319.152,205.781,318.84,207.62,319.413,208.062Z",
    transform: "translate(-257.4 -145.405)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M312.334,204.961s-4.072,2.4-4.2,3.223.94.5,1.845.256c1.147-.318,3.054-.776,3.307-1.835S313.477,204.786,312.334,204.961Z",
    transform: "translate(-250.703 -144.848)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M320.88,211.812a13.346,13.346,0,0,0,1.591,1.264c.316.128.956,0,.507-1.326a3.284,3.284,0,0,0-1.907-2.153C320.626,209.531,320.31,211.37,320.88,211.812Z",
    transform: "translate(-258.297 -147.7)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M313.8,208.745s-4.048,2.409-4.2,3.227.94.5,1.845.252c1.147-.318,3.054-.776,3.307-1.835S314.942,208.555,313.8,208.745Z",
    transform: "translate(-251.595 -147.162)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M321.946,215.6a12.076,12.076,0,0,0,1.4,1.109c.281.112.839,0,.445-1.164a2.865,2.865,0,0,0-1.673-1.885C321.724,213.6,321.443,215.209,321.946,215.6Z",
    transform: "translate(-258.969 -150.186)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M315.731,212.889s-3.573,2.11-3.686,2.831.827.442,1.622.221c1-.275,2.679-.663,2.9-1.61S316.737,212.723,315.731,212.889Z",
    transform: "translate(-253.09 -149.701)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M342.725,186.019s-6.584,7.416-7.5,8.1a32.445,32.445,0,0,1-3.085,1.819l1.505,5.228s9.361-4.546,13.148-6.935,6.513-3.751,6.4-4.887-4.115-5-4.115-5",
    transform: "translate(-265.353 -132.24)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M291.014,133.966a8.663,8.663,0,0,0-4.31,3.266A29.107,29.107,0,0,0,284.937,133c0,4.813-.117,11.465-.117,11.465S288.244,138.632,291.014,133.966Z",
    transform: "translate(-236.489 -100.813)",
    fill: "#3fb9ea",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgoTradingIcon);
export default __webpack_public_path__ + "static/media/algo_trading-icon.ae6fa4772ba60bec65c77a8ecc4121ae.svg";
export { ForwardRef as ReactComponent };